import axios from "axios";
var urlPrefix = process.env.VUE_APP_OMNI_BASE_URL;
var securityUrlPrefix = process.env.VUE_APP_OMNI_SECURITY_BASE_URL;

export function getUserAccess(data) {
  return axios
    .get(securityUrlPrefix + "/api/identity/getUserAccess", {
      params: {
        clientId: data.clientId,
        userId: data.userId,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
export async function sendFeedbackEmail(data) {
  return axios
    .post(urlPrefix + "/api/shared/sendFeedbackEmail", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}
export async function get(payload) {
  return axios
    .get(urlPrefix + "/api/get", {
      params: {},
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
export async function post(data) {
  return axios
    .post(urlPrefix + "/api/", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
export async function postQueryString(payload) {
  return axios
    .post(urlPrefix + "/api/", null, {
      params: {},
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
